"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_MEMO_CHARACTERS = exports.MAX_DATA_SIZE = exports.MAX_CLIENT_ID_LENGTH = void 0;
exports.MAX_CLIENT_ID_LENGTH = 128;
exports.MAX_DATA_SIZE = 256;
exports.MAX_MEMO_CHARACTERS = 256;
